import { useLayoutEffect, useState } from 'react';
import css from './error-overlay.module.scss';

export function ErrorOverlay() {
  const [isVisible, setIsVisible] = useState(false);

  useLayoutEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node instanceof HTMLElement &&
            node.tagName === 'IFRAME' &&
            node.id === 'webpack-dev-server-client-overlay'
          ) {
            setIsVisible(true);
            node.style.display = 'none';
            node.style.zIndex = '9998';
          }
        });

        mutation.removedNodes.forEach((node) => {
          if (node instanceof HTMLElement && node.tagName === 'IFRAME') {
            setIsVisible(false);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      className={css.button}
      onClick={() => {
        const overlay = document.querySelector('#webpack-dev-server-client-overlay');

        if (overlay instanceof HTMLIFrameElement) {
          const display = overlay.style.display === 'none' ? 'block' : 'none';
          overlay.style.display = display;
        }
      }}
    >
      !
    </button>
  );
}
